import { render, staticRenderFns } from "./CustomerTreatmentsTab.vue?vue&type=template&id=6d86b08a&"
import script from "./CustomerTreatmentsTab.vue?vue&type=script&lang=js&"
export * from "./CustomerTreatmentsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports